<template>
  <div class="balanceRecordForm">
    <el-table
        :data="formList"
        border
        stripe
        class="historyTable"
        style="width: 100%">
        <el-table-column
          prop="trade_serial_no"
          :label="pc_lang.reference_number"
          class-name="trade_serial_no"
          align="center"
          width="210">
        </el-table-column>
        <el-table-column
          prop="time"
          :label="pc_lang.Date"
          align="center"
          width="94">
        </el-table-column>
        <el-table-column
          prop="trade_notes"
          :label="pc_lang.Remark + '|' + pc_lang.Transaction_number"
          class-name="trade_notes"
          align="center">
          <template slot-scope="scope">
            <p v-text="scope.row.trade_notes"></p>
            <div v-text="scope.row.trade_serial_no"></div>
          </template>
        </el-table-column>
        <el-table-column
          prop="amount"
          :label="pc_lang.Changable_amount"
          align="center"
          class-name="amount"
          width="120">
          <template slot-scope="scope">
            <span v-text="scope.row.amount" class="minus" v-if="parseFloat(scope.row.amount) < 0"></span>
            <span v-text="scope.row.amount" class="plus" v-else></span>
          </template>
        </el-table-column>
        <el-table-column
          prop="remainder"
          :label="pc_lang.Credit_Balance"
          align="center"
          width="120">
        </el-table-column>
        <el-table-column
          prop="currency_short"
          :label="pc_lang.transaction_currency"
          align="center"
          class-name="currency_short"
          width="100">
        </el-table-column>
        <el-table-column
          prop="type"
          :label="pc_lang.Transaction_Type"
          align="center"
          width="120">
          <template slot-scope="scope">
            {{ getStatusWords(scope.row.type) }}
          </template>
        </el-table-column>
        <el-table-column
          :label="pc_lang.Operate"
          align="center"
          width="120">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row)" type="text" size="small" class="maincolor">{{pc_lang.View}}</el-button>
          </template>
        </el-table-column>
      </el-table>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'BalanceRecordForm',
  props: {
    formList: {
      type: Array,
      default: ()=> new Array
    }
  },
  components: {

  },
  computed: {

  },
  async mounted() {

  },
  methods: {
    /* 查看详情 */
    handleClick(item) {
      this.$router.push({path: '/balanceDetails?id=' + item.id})
    },
    /* 对应状态的文字 */
    getStatusWords(type) {
      let words = this.dealType.filter(obj=> {
        return obj.id == type
      })[0]
      return !!words ? words.words : '-'
    }
  }
}
</script>
<style lang="scss" scoped>

.historyTable{
  .trade_notes{
    p{
    }
    div{
      color: #bbb;
    }
  }
  .amount{
    .minus{
      color: #FF7B0E;
    }
    .plus{
      color: #1BB974;
    }
  }
}
.maincolor{
  color: $blue;
}
::v-deep.el-table th>.cell{
  word-break: keep-all;
}
</style>